module.exports = __webpack_public_path__ + "img/t4-open-content.21bc07b8.png";